import type {HideableValue, RichTextContent} from '@wix/devzai-utils-common';
import {hideableValueCreateHidden} from '@wix/devzai-utils-common';
import type {WixMediaResource} from '@wix/devzai-common-wix';
import type {DoppeDtoAction} from '../doppe-dto-action';

export interface DoppePageLockSettings {
    lockActions: DoppeDtoAction<any>[];
    enableLock: boolean;
    customPreviewContent: boolean;
    customLockPreviewButtonText: HideableValue<string>;
    customLockPreviewTitle: HideableValue<string>;
    customLockPreviewDescription: HideableValue<RichTextContent>;
    customLockPreviewMedia: WixMediaResource | null;
}

export function doppePageLockSettingsGetDefault(): DoppePageLockSettings {
    return {
        lockActions: [],
        enableLock: false,
        customLockPreviewTitle: '',
        customLockPreviewDescription: '',
        customLockPreviewMedia: null,
        customLockPreviewButtonText: hideableValueCreateHidden(''),
        customPreviewContent: false,
    };
}

export function doppePageLockSettingsResolve(
    lockSettings: DoppePageLockSettings | undefined
): DoppePageLockSettings {
    if (lockSettings === undefined) {
        return doppePageLockSettingsGetDefault();
    }

    return {
        ...doppePageLockSettingsGetDefault(),
        ...lockSettings,
    };
}

export function doppePageIsLockEnabled(lockSettings: DoppePageLockSettings | undefined): boolean {
    return lockSettings?.enableLock ?? false;
}

export function doppePageIsLockActive(lockSettings: DoppePageLockSettings | undefined): boolean {
    return doppePageIsLockEnabled(lockSettings) && doppePageHasLockAction(lockSettings);
}

export function doppePageHasLockAction(lockSettings: DoppePageLockSettings | undefined): boolean {
    return (lockSettings?.lockActions.length ?? 0) > 0;
}
